// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/landscapes/good.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/landscapes/moderate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/images/landscapes/unhealthy-groups.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/images/landscapes/unhealthy.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/images/landscapes/very-unhealthy.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/images/landscapes/hazardous.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root */

:root {
  --primary: #54c9ef;
  --secondary: #6566c0;

  --good: #38d020;
  --moderate: #e7be27;
  --unhealthy-groups: #f28330;
  --unhealthy: #e9474a;
  --very-unhealthy: #923bc5;
  --hazardous: #7b2d51;

  --good-dark: #2e8121;
  --moderate-dark: #bd970b;
  --unhealthy-groups-dark: #c76215;
  --unhealthy-dark: #c01619;
  --very-unhealthy-dark: #6e1c9e;
  --hazardous-dark: #551633;

  --good-50: #38d0207b;
  --unhealthy-50: #e9474a82;

  --good-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --moderate-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  --unhealthy-groups-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  --unhealthy-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  --very-unhealthy-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  --hazardous-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

/*     */

* {
  padding: 0;
  margin: 0;
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
  text-decoration: none;
}

html {
  scroll-behavior: smooth;
}

h1,h2,h3,h4,h5 {
  line-height: 125%;
  margin-bottom: .25rem;
}

a,
button,
input,
textarea {
  min-height: 44px;
  min-width: 44px;
  display: inline-block;
}

.skip-link {
  position: absolute;
  top: -60px;
  left: 0;
  padding: 8px;
  background-color: #bf1722;
  color: white;
  z-index: 100;
}

.skip-link:focus {
  top: 0;
}

header {
  display: flex;
  height: 80px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 999;
}

main {
  min-height: min-content;
}

/* Hero */
.hero {
  background-color: var(--primary);
  display: flex;
  flex-wrap: nowrap;
  padding: 3em;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.hero p {
  color: #412e8a;
  padding-right: 7vw;
  font-size: larger;
}

.hero h2 {
  font-size: clamp(52px, 5vw, 100px);
  color: white;
  margin-bottom: -.5rem;
}

.hero .image-hero img {
  max-width: 350px;
}

/* Main Page */

.main {
  width: 100%;
}

.next-btn {
  width: fit-content;
  background: linear-gradient(45deg, rgba(101, 102, 192, 1), rgba(56, 57, 149, 1));
  color: white;
  font-size: clamp(16px, 1.25vw, 800px);
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: .5rem 3rem;
  border-radius: 100px;
  margin-top: 2rem;
}

.next-btn:hover,
.maps-btn:hover {
  scale: 105%;
}

.main .section-title {
  font-size: 32px;
  margin: 1em 1em 0;
  text-align: center;
}

.main .hero p:nth-child(3) {
  font-style: normal;
  color: white;
  font-size: smaller;
}

.main .summary,
.main .summary-section,
.main .rank-section,
.main .summary-side {
  margin: auto;
  display: grid;
  gap: 2em;
}

.main .summary {
  grid-template-rows: repeat(2, auto);
  max-width: 1200px;
  padding: 20px;
  margin: 3em auto;
}

.summary-section {
  grid-template-columns: 2fr 1fr;
  grid-template-rows: 1fr;
}

.summary-side {
  height: 100%;
  grid-template-rows: 1fr 2fr;
  gap: 1em;
}

.map-section {
  border-radius: 10px;
  width: 100%;
}

.rank-section {
  grid-template-columns: repeat(2, 1fr);
}

.city-detail-link {
  color: black;
}

.city-detail-link:hover,
.city-detail-link:active {
  color: rgb(0, 140, 255);
}

.map-section {
  overflow: hidden;
  position: relative;
  height: 100%;
  background-color: #000;
  display: flex;
}

.map-section__image {
  opacity: 0.5;
  position: absolute;
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.map-section__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.inner {
  text-align: center;
  margin: auto;
  z-index: 2;
}

.inner p {
  font-weight: 600;
  color: white;
  margin-bottom: .5rem;
}

.inner a {
  background-color: var(--secondary);
  color: white;
  border-radius: 10px;
  padding: 0.7em;
}

.rank-section h2 {
  text-align: center;
  margin: 20px 0;
}

.topAqi-section, .bottomAqi-section {
  padding: 1rem;
  border-radius: 20px;
}

.topAqi-section h2, .bottomAqi-section h2{
  color: white;
  padding: 1rem;
  border-radius: 10px;
  width: 100%;
}

.topAqi-section h2 {
  background-color: var(--unhealthy);
}

.bottomAqi-section h2 {
  background-color: var(--good);
}

.rank-section table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.rank-section th,
.rank-section td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.rank-section th {
  background-color: #f2f2f2;
}

.rank-section tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.rank-section span.aqi-value {
  font-weight: bold;
}

.summary-side .fun-fact {
  padding: 1.5em;
  background-color: var(--primary);
  border-radius: 10px;
  height: 100%;
}

.summary-side .fun-fact .section-title {
  color: white;
  margin: 0.5em auto;
}

.summary-side .fun-fact .card-contain {
  display: flex;
  height: 300px;
}

.mySwiper {
  max-width: 300px;
  height: 100%;
}

.swiper-wrapper {
  height: 100%;
}

.summary-side .fun-fact .card {
  padding: 16px;
  background-color: white;
  box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  height: 100%;
}

.summary-side .fun-fact .card .card-header p {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  margin-bottom: 24px;
  text-align: center;
}

.summary-side .fun-fact .card .card-body {
  text-align: justify;
  display: flex;
  flex: 1 1 auto;
}

.summary-side .fun-fact .card .card-body .line {
  border-left: 4px solid var(--secondary);
  padding-right: 16px;
  margin-bottom: 41px;
  margin-top: 6px;
}

.summary-side .fun-fact .card .card-body p {
  font-size: 14px;
  margin-bottom: 36px;
  line-height: 1.43;
}
.summary-side .fun-fact .card .card-body span {
  font-size: 28px;
  font-weight: 500;
  color: var(--secondary);
  display: block;
  line-height: 1.5;
  margin-bottom: 2px;
}

.main .fun-fact__footer p {
  margin-top: 2em;
  text-align: center;
  color: white;
}

.main .fun-fact__footer p a {
  color: white;
}

.main .articles {
  margin-bottom: 3em;
}

.main .main-recommended-articles {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 0 3em;
  place-items: center;
  gap: 1rem;
}

.main-recommended-articles .blog-card {
  width: 100%;
}

.main .fitur {
  padding: 5rem 1rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}

.main .fitur h1 {
  text-align: center;
}

.main .fitur .card-contain {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
  height: 100%;
}

.main .fitur .card {
  width: 390px;
  border-radius: 20px;
  padding: 1.5rem;
  background-color: #ffffff;
  display: grid;
  grid-template-rows: 5fr 1.5fr;
}

.main .fitur .card .card-header {
  text-align: center;
  display: grid;
  grid-template-rows: 2fr 7fr;
  place-items: center;
}

.main .fitur .card .card-header h1 {
  font-size: clamp(24px, 1.5vw, 800px);
  color: #6566c0;
  font-weight: 700;
}

.main .fitur .card img {
  width: 225px;
  height: 192px;
  object-fit: cover;
  margin-bottom: 10px;
}

.main .fitur .card .card-body p{
  font-size: 16px;
}

/* About Page */
.reviews {
  padding-bottom: 5rem;
}

.reviews .heading {
  padding: 5rem 7% 1.4rem;
  font-size: 3rem;
  margin-bottom: 3rem;
  text-align: center;
  color: #0a0535;
}

.reviews .box-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem;
  align-items: flex-start;
  justify-content: center;
  padding: 0 1rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.reviews .box {
  width: 100%;
  height: 400px;
  justify-content: space-around;
  border: 3px solid rgb(238, 238, 238);
}

.reviews .box-container .box {
  border-radius: 0.5rem;
  background-color: var(--white);
  padding: 2rem;
}

.reviews .box-container .box .student {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  color: var(--black);
  font-size: clamp(17px, 1vw, 15px);
  max-width: 100%;
}

.student .details {
  display: flex;
  flex-direction: column;
}

.reviews .box-container .box .student img {
  height: 7rem;
  width: 7rem;
  object-fit: cover;
  border-radius: 50%;
  border: 5px solid white;
  outline: 5px solid rgb(0, 140, 255);
}

.reviews .box-container .box .student h3 {
  text-align: center;
  line-height: 100%;
}

.reviews .box-container .box .student .role {
  text-align: center;
  max-width: 90%;
  align-self: center;
  font-size: 12px;
  font-style: italic;
  margin: .5rem 0;
  color: rgb(123, 123, 123);
}

.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(45deg, rgb(233, 233, 233), white, rgb(225, 225, 225));
}

.logo-ref-team {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 1rem;
}

.logo-ref-team a {
  background-color: #1877f2;
  aspect-ratio: 1/1;
  display: flex;
  width: 50px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.fa-brands {
  font-size: 32px;
  color: white;
  border-radius: 50%;
  margin: 10px 15px; /* Atur jarak antar logo */
}

/* Maps Page */

#map {
  width: 100%;
  height: 100vh;
  z-index: 1;
}

#map a {
  min-width: 0;
  min-height: 0;
}

.leaflet-control-attribution {
  display: flex;
  justify-content: center;
  align-items: center;
}

.map-info {
  width: fit-content;
  z-index: 500;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  color: white;
  padding: 1rem 2rem;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.index-info {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1.25rem;
  font-size: clamp(0.5rem, 0.75vw, 800px);
}

.index-info .dot {
  min-width: 20px;
  min-height: 20px;
  border-radius: 50%;
  margin-right: 0.25rem;
}

.leaflet-popup-close-button {
  min-width: 0;
  min-height: 0;
}

.popup .container p {
  margin: 0;
}

.indexOnMap {
  display: flex;
  justify-content: center;
  align-items: center;
}

#indexOnMapContainer {
  width: 45%;
  border-radius: 50%;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 0.75rem;
}

.good {
  background-color: var(--good);
  border: 2px solid var(--good-dark);
}

.moderate {
  background-color: var(--moderate);
  border: 2px solid var(--moderate-dark);
}

.unhealthy-groups {
  background-color: var(--unhealthy-groups);
  border: 2px solid var(--unhealthy-groups-dark);
}

.unhealthy {
  background-color: var(--unhealthy);
  border: 2px solid var(--unhealthy-dark);
}

.very-unhealthy {
  background-color: var(--very-unhealthy);
  border: 2px solid var(--very-unhealthy-dark);
}

.hazardous {
  background-color: var(--hazardous);
  border: 2px solid var(--hazardous-dark);
}

.index-nan {
  background-color: lightgray;
}

.leaflet-popup-content-wrapper {
  height: fit-content;
  display: flex;
}

.leaflet-popup-content {
  height: fit-content;
  display: flex;
}

.leaflet-popup-content a {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
}

.index-color-bg {
  background-color: lightgray;
  color: white;
  width: 100%;
  margin-bottom: 1rem;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0.5rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-clip: border-box;
}

.aqi-container h1 {
  min-width: 59px;
  margin: 0;
  aspect-ratio: 1/1;
  margin: 0.25rem 0;
  padding: 0.35rem;
  border-radius: 50%;
  border: 4px solid white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup {
  width: 100%;
}

.popup .detail {
  box-sizing: border-box;
  background-color: rgb(0, 0, 0, 0.6);
  color: white;
  backdrop-filter: blur(20px);
  padding: 0.5rem;
  margin-top: 0.5rem;
  border-radius: 5px;
}

.good-url {
  background: var(--good-bg-img);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.moderate-url {
  background: var(--moderate-bg-img);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.unhealthy-groups-url {
  background: var(--unhealthy-groups-bg-img);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.unhealthy-url {
  background: var(--unhealthy-bg-img);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.very-unhealthy-url {
  background: var(--very-unhealthy-bg-img);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.hazardous-url {
  background: var(--hazardous-bg-img);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.to-detail-page {
  width: 100%;
  background-color: var(--secondary);
  padding: 0.5rem 1rem;
  text-decoration: none;
  border-radius: 5px;
  margin-top: 0.5rem;
  text-decoration: none;
  text-align: center;
}

.to-detail-page span {
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.to-detail-page span i {
  margin-left: 0.25rem;
}

/* Detail Page */
#detailContainer,
.detail-content-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#detailContainer {
  padding: 1rem 10rem;
  gap: 3rem;
}

.detail-content-container {
  gap: 1rem;
}

.aqi-label {
  background-color: rgba(0, 0, 0, 0.35);
  padding: 0.5rem 2rem;
  border-radius: 5px;
  backdrop-filter: blur(20px);
}

.detail-content,
.summary-content {
  width: 100%;
  background-color: lightgray;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  padding: 1rem;
}

.summary-content {
  height: 100%;
}

.shadow {
  box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.075);
}

.aqi-detail-container {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 1rem;
  border-radius: 20px;
}

.aqi-index-detail h1 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.aqi-detail-container h1 {
  line-height: 100%;
  margin-bottom: 0.5rem;
}

.aqi-index-detail {
  width: max-content;
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: clamp(40px, 4vw, 800px);
  color: white;
  background-color: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(20px);
  border-radius: 50%;
  border: 10px solid white;
  margin: 1rem 3rem 3rem;
  padding: 1rem;
  aspect-ratio: 1/1;
}

.current-aqi-info {
  background-color: rgba(0, 225, 255, 0.15);
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.current-aqi-info p {
  font-size: clamp(14px, 1vw, 800px);
}

.charts {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.aqi-chart-card {
  width: 100%;
  height: 50vw;
  max-height: 350px;
  padding: 1rem;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgb(255, 255, 255);
}

.attributions {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 1rem;
}

.data-source {
  background-color: var(--secondary);
  padding: 0.5rem 1rem;
  text-decoration: none;
  border-radius: 5px;
}

.data-source,
.data-source a {
  color: white;
  font-size: 12px;
}

.data-source a {
  min-height: 0;
  font-weight: bold;
}

.detail-recommended-articles {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding: 1rem 0;
}

.detail-recommended-articles h2 {
  text-align: center;
}

.detail-recommended-articles-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.detail-recommended-articles .blog-card {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.detail-recommended-articles .blog-card img {
  width: 100%;
  min-height: 100%;
}

.detail-recommended-articles .blog-card .text {
  grid-template-rows: 5fr 1fr;
}

/* Blogs Page */
.blog-list-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.blog-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
}

.blog-card {
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.75rem;
  border-radius: 10px;
}

.blog-card img {
  width: 100%;
  height: 200px;
  min-height: 200px;
  object-fit: cover;
  border-radius: 5px;
}

.blog-card .text {
  width: 100%;
  display: grid;
  grid-template-rows: 7fr 1fr;
}

.blog-card .title {
  font-size: 20px;
}

.blog-card .overview {
  display: grid;
  grid-template-rows: auto auto;
  gap: 0.5rem;
  font-size: 14px;
  text-align: justify;
}

.blog-card a {
  width: 100%;
  background-color: var(--secondary);
  color: white;
  font-weight: bold;
  min-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0;
  text-align: center;
  border-radius: 5px;
  font-size: 16px;
  margin-top: 0.5rem;
}

/* Blog Article Page */
.blog-article {
  width: 100%;
  padding: 1.5rem;
  display: grid;
  grid-template-columns: 75fr 25fr;
  gap: 3rem;
}

.article-content,
.article-content article {
  display: flex;
  flex-direction: column;
}

.article-content h1 {
  font-size: clamp(24px, 2.5vw, 800px);
  line-height: 120%;
}

.article-content p::first-letter {
  margin-left: 1em;
}

.article-content p {
  text-align: justify;
}

.article-content img {
  object-fit: cover;
  min-height: 450px;
}

.blog-article .recommended-articles {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  height: fit-content;
  border-radius: 10px;
}

.recommended-articles-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.blog-article .recommended-articles .blog-card {
  width: 100%;
  flex-direction: column;
}

.blog-article .recommended-articles .blog-card img {
  max-width: 100%;
  min-height: 200px;
  height: 200px;
  object-fit: cover;
}

.blog-article .recommended-articles .text {
  display: grid;
  grid-template-rows: 3fr 1fr;
}

.blog-article .recommended-articles .blog-card .title {
  font-size: 14px;
}

.blog-article .recommended-articles .blog-card .overview,
.blog-article .recommended-articles .blog-card .overview a {
  font-size: 12px;
}

.recommended-articles .blog-card a {
  font-size: 14px;
}

.share-links {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.5rem;
  margin: 1rem 0;
  width: 100%;
}

.share-link-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: lightgray;
  aspect-ratio: 1/1;
  width: 44px;
  height: 44px;
  border-radius: 50%;
}

.share-link-button i {
  font-size: 24px;
  color: white;
}

.copy-to-clipboard {
  background-color: #1f1f1f;
}

.whatsapp {
  background-color: #25d366;
}

.facebook {
  background-color: #1877f2;
}

.x-twitter {
  background-color: #1f1f1f;
}

.image-source {
  width: 100%;
  display: flex;
  color: rgb(162, 162, 162);
  margin: 0.5rem 0 1rem;
  font-size: clamp(10px, 1vw, 800px);
  text-align: center;
  align-self: center;
  word-wrap: break-word;
  word-break: break-all;
}

.divider {
  border-top: 3px solid rgb(233, 233, 233);
  width: 100%;
  margin: 2.5rem 0;
}

/* Error Page */
.error-page {
  width: 100%;
  padding: 2em;
  text-align: center;
}

.error-page__info {
  line-height: 2;
}

.error-page__info h1 {
  color: var(--primary);
  font-size: xxx-large;
}

.error-page__hero img {
  max-width: 60%;
}

/* Footer */
footer {
  background-color: var(--primary);
  width: 100%;
  padding: 1rem;
  align-self: end;
}

/* Lainnya */
#customAlert {
  width: max-content;
  position: fixed;
  padding: .5rem 2rem;
  top: -100px;
  right: 50%;
  opacity: 0%;
  transform: translateX(50%);
  background-color: gray;
  color: white;
  text-align: center;
  border-radius: 50px;
  transition: 0.3s;
  z-index: 999;
  font-size: clamp(14px, 1vw, 800px);
  display: flex;
  justify-content: center;
  align-items: center;
}

#customAlert i {
  margin-right: .35rem;
}

#loader {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  opacity: 100%;
  pointer-events: all;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1999;
}

#loader.hidden {
  opacity: 0%;
  pointer-events: none;
  transition: 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAEA,SAAS;;AAET;EACE,kBAAkB;EAClB,oBAAoB;;EAEpB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;;EAEpB,oBAAoB;EACpB,wBAAwB;EACxB,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;;EAEzB,oBAAoB;EACpB,yBAAyB;;EAEzB,sDAAwD;EACxD,0DAAgE;EAChE,kEAAgF;EAChF,2DAAkE;EAClE,gEAA4E;EAC5E,2DAAkE;AACpE;;AAEA,QAAQ;;AAER;EACE,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,gCAAgC;EAChC,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;;AAEd;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gFAAgF;EAChF,YAAY;EACZ,qCAAqC;EACrC,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;EAIE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gDAAgD;EAChD,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB,EAAE,0BAA0B;AAC/C;;AAEA,cAAc;;AAEd;EACE,WAAW;EACX,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');\n\n/* Root */\n\n:root {\n  --primary: #54c9ef;\n  --secondary: #6566c0;\n\n  --good: #38d020;\n  --moderate: #e7be27;\n  --unhealthy-groups: #f28330;\n  --unhealthy: #e9474a;\n  --very-unhealthy: #923bc5;\n  --hazardous: #7b2d51;\n\n  --good-dark: #2e8121;\n  --moderate-dark: #bd970b;\n  --unhealthy-groups-dark: #c76215;\n  --unhealthy-dark: #c01619;\n  --very-unhealthy-dark: #6e1c9e;\n  --hazardous-dark: #551633;\n\n  --good-50: #38d0207b;\n  --unhealthy-50: #e9474a82;\n\n  --good-bg-img: url(../public/images/landscapes/good.jpg);\n  --moderate-bg-img: url(../public/images/landscapes/moderate.png);\n  --unhealthy-groups-bg-img: url(../public/images/landscapes/unhealthy-groups.jpg);\n  --unhealthy-bg-img: url(../public/images/landscapes/unhealthy.jpg);\n  --very-unhealthy-bg-img: url(../public/images/landscapes/very-unhealthy.jpg);\n  --hazardous-bg-img: url(../public/images/landscapes/hazardous.jpg);\n}\n\n/*     */\n\n* {\n  padding: 0;\n  margin: 0;\n  font-family: 'Poppins', sans-serif;\n  box-sizing: border-box;\n  text-decoration: none;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nh1,h2,h3,h4,h5 {\n  line-height: 125%;\n  margin-bottom: .25rem;\n}\n\na,\nbutton,\ninput,\ntextarea {\n  min-height: 44px;\n  min-width: 44px;\n  display: inline-block;\n}\n\n.skip-link {\n  position: absolute;\n  top: -60px;\n  left: 0;\n  padding: 8px;\n  background-color: #bf1722;\n  color: white;\n  z-index: 100;\n}\n\n.skip-link:focus {\n  top: 0;\n}\n\nheader {\n  display: flex;\n  height: 80px;\n  width: 100%;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n}\n\nmain {\n  min-height: min-content;\n}\n\n/* Hero */\n.hero {\n  background-color: var(--primary);\n  display: flex;\n  flex-wrap: nowrap;\n  padding: 3em;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.hero p {\n  color: #412e8a;\n  padding-right: 7vw;\n  font-size: larger;\n}\n\n.hero h2 {\n  font-size: clamp(52px, 5vw, 100px);\n  color: white;\n  margin-bottom: -.5rem;\n}\n\n.hero .image-hero img {\n  max-width: 350px;\n}\n\n/* Main Page */\n\n.main {\n  width: 100%;\n}\n\n.next-btn {\n  width: fit-content;\n  background: linear-gradient(45deg, rgba(101, 102, 192, 1), rgba(56, 57, 149, 1));\n  color: white;\n  font-size: clamp(16px, 1.25vw, 800px);\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: .5rem 3rem;\n  border-radius: 100px;\n  margin-top: 2rem;\n}\n\n.next-btn:hover,\n.maps-btn:hover {\n  scale: 105%;\n}\n\n.main .section-title {\n  font-size: 32px;\n  margin: 1em 1em 0;\n  text-align: center;\n}\n\n.main .hero p:nth-child(3) {\n  font-style: normal;\n  color: white;\n  font-size: smaller;\n}\n\n.main .summary,\n.main .summary-section,\n.main .rank-section,\n.main .summary-side {\n  margin: auto;\n  display: grid;\n  gap: 2em;\n}\n\n.main .summary {\n  grid-template-rows: repeat(2, auto);\n  max-width: 1200px;\n  padding: 20px;\n  margin: 3em auto;\n}\n\n.summary-section {\n  grid-template-columns: 2fr 1fr;\n  grid-template-rows: 1fr;\n}\n\n.summary-side {\n  height: 100%;\n  grid-template-rows: 1fr 2fr;\n  gap: 1em;\n}\n\n.map-section {\n  border-radius: 10px;\n  width: 100%;\n}\n\n.rank-section {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.city-detail-link {\n  color: black;\n}\n\n.city-detail-link:hover,\n.city-detail-link:active {\n  color: rgb(0, 140, 255);\n}\n\n.map-section {\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n  background-color: #000;\n  display: flex;\n}\n\n.map-section__image {\n  opacity: 0.5;\n  position: absolute;\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n}\n\n.map-section__image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.inner {\n  text-align: center;\n  margin: auto;\n  z-index: 2;\n}\n\n.inner p {\n  font-weight: 600;\n  color: white;\n  margin-bottom: .5rem;\n}\n\n.inner a {\n  background-color: var(--secondary);\n  color: white;\n  border-radius: 10px;\n  padding: 0.7em;\n}\n\n.rank-section h2 {\n  text-align: center;\n  margin: 20px 0;\n}\n\n.topAqi-section, .bottomAqi-section {\n  padding: 1rem;\n  border-radius: 20px;\n}\n\n.topAqi-section h2, .bottomAqi-section h2{\n  color: white;\n  padding: 1rem;\n  border-radius: 10px;\n  width: 100%;\n}\n\n.topAqi-section h2 {\n  background-color: var(--unhealthy);\n}\n\n.bottomAqi-section h2 {\n  background-color: var(--good);\n}\n\n.rank-section table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.rank-section th,\n.rank-section td {\n  border: 1px solid #ddd;\n  padding: 10px;\n  text-align: left;\n}\n\n.rank-section th {\n  background-color: #f2f2f2;\n}\n\n.rank-section tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.rank-section span.aqi-value {\n  font-weight: bold;\n}\n\n.summary-side .fun-fact {\n  padding: 1.5em;\n  background-color: var(--primary);\n  border-radius: 10px;\n  height: 100%;\n}\n\n.summary-side .fun-fact .section-title {\n  color: white;\n  margin: 0.5em auto;\n}\n\n.summary-side .fun-fact .card-contain {\n  display: flex;\n  height: 300px;\n}\n\n.mySwiper {\n  max-width: 300px;\n  height: 100%;\n}\n\n.swiper-wrapper {\n  height: 100%;\n}\n\n.summary-side .fun-fact .card {\n  padding: 16px;\n  background-color: white;\n  box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  height: 100%;\n}\n\n.summary-side .fun-fact .card .card-header p {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.summary-side .fun-fact .card .card-body {\n  text-align: justify;\n  display: flex;\n  flex: 1 1 auto;\n}\n\n.summary-side .fun-fact .card .card-body .line {\n  border-left: 4px solid var(--secondary);\n  padding-right: 16px;\n  margin-bottom: 41px;\n  margin-top: 6px;\n}\n\n.summary-side .fun-fact .card .card-body p {\n  font-size: 14px;\n  margin-bottom: 36px;\n  line-height: 1.43;\n}\n.summary-side .fun-fact .card .card-body span {\n  font-size: 28px;\n  font-weight: 500;\n  color: var(--secondary);\n  display: block;\n  line-height: 1.5;\n  margin-bottom: 2px;\n}\n\n.main .fun-fact__footer p {\n  margin-top: 2em;\n  text-align: center;\n  color: white;\n}\n\n.main .fun-fact__footer p a {\n  color: white;\n}\n\n.main .articles {\n  margin-bottom: 3em;\n}\n\n.main .main-recommended-articles {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  margin: 0 3em;\n  place-items: center;\n  gap: 1rem;\n}\n\n.main-recommended-articles .blog-card {\n  width: 100%;\n}\n\n.main .fitur {\n  padding: 5rem 1rem 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.main .fitur h1 {\n  text-align: center;\n}\n\n.main .fitur .card-contain {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 2rem;\n  height: 100%;\n}\n\n.main .fitur .card {\n  width: 390px;\n  border-radius: 20px;\n  padding: 1.5rem;\n  background-color: #ffffff;\n  display: grid;\n  grid-template-rows: 5fr 1.5fr;\n}\n\n.main .fitur .card .card-header {\n  text-align: center;\n  display: grid;\n  grid-template-rows: 2fr 7fr;\n  place-items: center;\n}\n\n.main .fitur .card .card-header h1 {\n  font-size: clamp(24px, 1.5vw, 800px);\n  color: #6566c0;\n  font-weight: 700;\n}\n\n.main .fitur .card img {\n  width: 225px;\n  height: 192px;\n  object-fit: cover;\n  margin-bottom: 10px;\n}\n\n.main .fitur .card .card-body p{\n  font-size: 16px;\n}\n\n/* About Page */\n.reviews {\n  padding-bottom: 5rem;\n}\n\n.reviews .heading {\n  padding: 5rem 7% 1.4rem;\n  font-size: 3rem;\n  margin-bottom: 3rem;\n  text-align: center;\n  color: #0a0535;\n}\n\n.reviews .box-container {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 2rem;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0 1rem 1rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.reviews .box {\n  width: 100%;\n  height: 400px;\n  justify-content: space-around;\n  border: 3px solid rgb(238, 238, 238);\n}\n\n.reviews .box-container .box {\n  border-radius: 0.5rem;\n  background-color: var(--white);\n  padding: 2rem;\n}\n\n.reviews .box-container .box .student {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  color: var(--black);\n  font-size: clamp(17px, 1vw, 15px);\n  max-width: 100%;\n}\n\n.student .details {\n  display: flex;\n  flex-direction: column;\n}\n\n.reviews .box-container .box .student img {\n  height: 7rem;\n  width: 7rem;\n  object-fit: cover;\n  border-radius: 50%;\n  border: 5px solid white;\n  outline: 5px solid rgb(0, 140, 255);\n}\n\n.reviews .box-container .box .student h3 {\n  text-align: center;\n  line-height: 100%;\n}\n\n.reviews .box-container .box .student .role {\n  text-align: center;\n  max-width: 90%;\n  align-self: center;\n  font-size: 12px;\n  font-style: italic;\n  margin: .5rem 0;\n  color: rgb(123, 123, 123);\n}\n\n.box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: linear-gradient(45deg, rgb(233, 233, 233), white, rgb(225, 225, 225));\n}\n\n.logo-ref-team {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n  gap: 1rem;\n}\n\n.logo-ref-team a {\n  background-color: #1877f2;\n  aspect-ratio: 1/1;\n  display: flex;\n  width: 50px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px;\n}\n\n.fa-brands {\n  font-size: 32px;\n  color: white;\n  border-radius: 50%;\n  margin: 10px 15px; /* Atur jarak antar logo */\n}\n\n/* Maps Page */\n\n#map {\n  width: 100%;\n  height: 100vh;\n  z-index: 1;\n}\n\n#map a {\n  min-width: 0;\n  min-height: 0;\n}\n\n.leaflet-control-attribution {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.map-info {\n  width: fit-content;\n  z-index: 500;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 50px;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(20px);\n  color: white;\n  padding: 1rem 2rem;\n  border-radius: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.index-info {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 1.25rem;\n  font-size: clamp(0.5rem, 0.75vw, 800px);\n}\n\n.index-info .dot {\n  min-width: 20px;\n  min-height: 20px;\n  border-radius: 50%;\n  margin-right: 0.25rem;\n}\n\n.leaflet-popup-close-button {\n  min-width: 0;\n  min-height: 0;\n}\n\n.popup .container p {\n  margin: 0;\n}\n\n.indexOnMap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#indexOnMapContainer {\n  width: 45%;\n  border-radius: 50%;\n  aspect-ratio: 1/1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-weight: bold;\n  font-size: 0.75rem;\n}\n\n.good {\n  background-color: var(--good);\n  border: 2px solid var(--good-dark);\n}\n\n.moderate {\n  background-color: var(--moderate);\n  border: 2px solid var(--moderate-dark);\n}\n\n.unhealthy-groups {\n  background-color: var(--unhealthy-groups);\n  border: 2px solid var(--unhealthy-groups-dark);\n}\n\n.unhealthy {\n  background-color: var(--unhealthy);\n  border: 2px solid var(--unhealthy-dark);\n}\n\n.very-unhealthy {\n  background-color: var(--very-unhealthy);\n  border: 2px solid var(--very-unhealthy-dark);\n}\n\n.hazardous {\n  background-color: var(--hazardous);\n  border: 2px solid var(--hazardous-dark);\n}\n\n.index-nan {\n  background-color: lightgray;\n}\n\n.leaflet-popup-content-wrapper {\n  height: fit-content;\n  display: flex;\n}\n\n.leaflet-popup-content {\n  height: fit-content;\n  display: flex;\n}\n\n.leaflet-popup-content a {\n  width: 100%;\n  height: fit-content;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.index-color-bg {\n  background-color: lightgray;\n  color: white;\n  width: 100%;\n  margin-bottom: 1rem;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 0.5rem;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-clip: border-box;\n}\n\n.aqi-container h1 {\n  min-width: 59px;\n  margin: 0;\n  aspect-ratio: 1/1;\n  margin: 0.25rem 0;\n  padding: 0.35rem;\n  border-radius: 50%;\n  border: 4px solid white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.popup {\n  width: 100%;\n}\n\n.popup .detail {\n  box-sizing: border-box;\n  background-color: rgb(0, 0, 0, 0.6);\n  color: white;\n  backdrop-filter: blur(20px);\n  padding: 0.5rem;\n  margin-top: 0.5rem;\n  border-radius: 5px;\n}\n\n.good-url {\n  background: var(--good-bg-img);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.moderate-url {\n  background: var(--moderate-bg-img);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.unhealthy-groups-url {\n  background: var(--unhealthy-groups-bg-img);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.unhealthy-url {\n  background: var(--unhealthy-bg-img);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.very-unhealthy-url {\n  background: var(--very-unhealthy-bg-img);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.hazardous-url {\n  background: var(--hazardous-bg-img);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.to-detail-page {\n  width: 100%;\n  background-color: var(--secondary);\n  padding: 0.5rem 1rem;\n  text-decoration: none;\n  border-radius: 5px;\n  margin-top: 0.5rem;\n  text-decoration: none;\n  text-align: center;\n}\n\n.to-detail-page span {\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.to-detail-page span i {\n  margin-left: 0.25rem;\n}\n\n/* Detail Page */\n#detailContainer,\n.detail-content-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n#detailContainer {\n  padding: 1rem 10rem;\n  gap: 3rem;\n}\n\n.detail-content-container {\n  gap: 1rem;\n}\n\n.aqi-label {\n  background-color: rgba(0, 0, 0, 0.35);\n  padding: 0.5rem 2rem;\n  border-radius: 5px;\n  backdrop-filter: blur(20px);\n}\n\n.detail-content,\n.summary-content {\n  width: 100%;\n  background-color: lightgray;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 20px;\n  padding: 1rem;\n}\n\n.summary-content {\n  height: 100%;\n}\n\n.shadow {\n  box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.075);\n}\n\n.aqi-detail-container {\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  padding: 1rem;\n  border-radius: 20px;\n}\n\n.aqi-index-detail h1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.aqi-detail-container h1 {\n  line-height: 100%;\n  margin-bottom: 0.5rem;\n}\n\n.aqi-index-detail {\n  width: max-content;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-size: clamp(40px, 4vw, 800px);\n  color: white;\n  background-color: rgba(0, 0, 0, 0.35);\n  backdrop-filter: blur(20px);\n  border-radius: 50%;\n  border: 10px solid white;\n  margin: 1rem 3rem 3rem;\n  padding: 1rem;\n  aspect-ratio: 1/1;\n}\n\n.current-aqi-info {\n  background-color: rgba(0, 225, 255, 0.15);\n  padding: 1rem;\n  margin-top: 1rem;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.current-aqi-info p {\n  font-size: clamp(14px, 1vw, 800px);\n}\n\n.charts {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.aqi-chart-card {\n  width: 100%;\n  height: 50vw;\n  max-height: 350px;\n  padding: 1rem;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: rgb(255, 255, 255);\n}\n\n.attributions {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.data-source {\n  background-color: var(--secondary);\n  padding: 0.5rem 1rem;\n  text-decoration: none;\n  border-radius: 5px;\n}\n\n.data-source,\n.data-source a {\n  color: white;\n  font-size: 12px;\n}\n\n.data-source a {\n  min-height: 0;\n  font-weight: bold;\n}\n\n.detail-recommended-articles {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  padding: 1rem 0;\n}\n\n.detail-recommended-articles h2 {\n  text-align: center;\n}\n\n.detail-recommended-articles-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.detail-recommended-articles .blog-card {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n\n.detail-recommended-articles .blog-card img {\n  width: 100%;\n  min-height: 100%;\n}\n\n.detail-recommended-articles .blog-card .text {\n  grid-template-rows: 5fr 1fr;\n}\n\n/* Blogs Page */\n.blog-list-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.blog-container {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  justify-content: center;\n}\n\n.blog-card {\n  width: 300px;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 0.75rem;\n  border-radius: 10px;\n}\n\n.blog-card img {\n  width: 100%;\n  height: 200px;\n  min-height: 200px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.blog-card .text {\n  width: 100%;\n  display: grid;\n  grid-template-rows: 7fr 1fr;\n}\n\n.blog-card .title {\n  font-size: 20px;\n}\n\n.blog-card .overview {\n  display: grid;\n  grid-template-rows: auto auto;\n  gap: 0.5rem;\n  font-size: 14px;\n  text-align: justify;\n}\n\n.blog-card a {\n  width: 100%;\n  background-color: var(--secondary);\n  color: white;\n  font-weight: bold;\n  min-height: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0;\n  text-align: center;\n  border-radius: 5px;\n  font-size: 16px;\n  margin-top: 0.5rem;\n}\n\n/* Blog Article Page */\n.blog-article {\n  width: 100%;\n  padding: 1.5rem;\n  display: grid;\n  grid-template-columns: 75fr 25fr;\n  gap: 3rem;\n}\n\n.article-content,\n.article-content article {\n  display: flex;\n  flex-direction: column;\n}\n\n.article-content h1 {\n  font-size: clamp(24px, 2.5vw, 800px);\n  line-height: 120%;\n}\n\n.article-content p::first-letter {\n  margin-left: 1em;\n}\n\n.article-content p {\n  text-align: justify;\n}\n\n.article-content img {\n  object-fit: cover;\n  min-height: 450px;\n}\n\n.blog-article .recommended-articles {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  height: fit-content;\n  border-radius: 10px;\n}\n\n.recommended-articles-container {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.blog-article .recommended-articles .blog-card {\n  width: 100%;\n  flex-direction: column;\n}\n\n.blog-article .recommended-articles .blog-card img {\n  max-width: 100%;\n  min-height: 200px;\n  height: 200px;\n  object-fit: cover;\n}\n\n.blog-article .recommended-articles .text {\n  display: grid;\n  grid-template-rows: 3fr 1fr;\n}\n\n.blog-article .recommended-articles .blog-card .title {\n  font-size: 14px;\n}\n\n.blog-article .recommended-articles .blog-card .overview,\n.blog-article .recommended-articles .blog-card .overview a {\n  font-size: 12px;\n}\n\n.recommended-articles .blog-card a {\n  font-size: 14px;\n}\n\n.share-links {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 0.5rem;\n  margin: 1rem 0;\n  width: 100%;\n}\n\n.share-link-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: lightgray;\n  aspect-ratio: 1/1;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n}\n\n.share-link-button i {\n  font-size: 24px;\n  color: white;\n}\n\n.copy-to-clipboard {\n  background-color: #1f1f1f;\n}\n\n.whatsapp {\n  background-color: #25d366;\n}\n\n.facebook {\n  background-color: #1877f2;\n}\n\n.x-twitter {\n  background-color: #1f1f1f;\n}\n\n.image-source {\n  width: 100%;\n  display: flex;\n  color: rgb(162, 162, 162);\n  margin: 0.5rem 0 1rem;\n  font-size: clamp(10px, 1vw, 800px);\n  text-align: center;\n  align-self: center;\n  word-wrap: break-word;\n  word-break: break-all;\n}\n\n.divider {\n  border-top: 3px solid rgb(233, 233, 233);\n  width: 100%;\n  margin: 2.5rem 0;\n}\n\n/* Error Page */\n.error-page {\n  width: 100%;\n  padding: 2em;\n  text-align: center;\n}\n\n.error-page__info {\n  line-height: 2;\n}\n\n.error-page__info h1 {\n  color: var(--primary);\n  font-size: xxx-large;\n}\n\n.error-page__hero img {\n  max-width: 60%;\n}\n\n/* Footer */\nfooter {\n  background-color: var(--primary);\n  width: 100%;\n  padding: 1rem;\n  align-self: end;\n}\n\n/* Lainnya */\n#customAlert {\n  width: max-content;\n  position: fixed;\n  padding: .5rem 2rem;\n  top: -100px;\n  right: 50%;\n  opacity: 0%;\n  transform: translateX(50%);\n  background-color: gray;\n  color: white;\n  text-align: center;\n  border-radius: 50px;\n  transition: 0.3s;\n  z-index: 999;\n  font-size: clamp(14px, 1vw, 800px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#customAlert i {\n  margin-right: .35rem;\n}\n\n#loader {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  opacity: 100%;\n  pointer-events: all;\n  background-color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1999;\n}\n\n#loader.hidden {\n  opacity: 0%;\n  pointer-events: none;\n  transition: 0.3s;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
